var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/gatsby/~/webpack/~/node-libs-browser/~/buffer/~/isarray/index.js
 ** module id = 423
 ** module chunks = 0
 **/